import {
    Card,
    Table,
    Spinner,
    Alert,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";
import useSignFormPayload from "../form/hooks/useSignFormPayload";
import { Printer } from "react-feather";
import { SnackbarAlert } from "../../../../../components/SnackbarAlert";


const StudentSignedDocsTable = () => {
    const {
        payload,
        studentDropdownData,
        signedStudentIds,
        loadingSignedDocs,
        fetchMergedSignedPdfs,
        mergedPdfError,
        loadingMergedPdf,
        notif,
        setNotif
    } = useSignFormPayload();

    if (!payload.template_id) {
        return null;
    }

    if (loadingSignedDocs) {
        return (
            <Card className="mt-3">
                <Card.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <p className="mt-2">Checking for signed documents...</p>
                </Card.Body>
            </Card>
        );
    }

    const signedCount = signedStudentIds.length;
    const totalStudents = studentDropdownData?.length || 0;

    return (
        <>
            <Card className="mt-3">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5>
                            Student Documents
                            <small className="text-muted ms-2">
                                ({signedCount} of {totalStudents} signed)
                            </small>
                        </h5>

                        <div>
                            {/* <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Download Forms</Tooltip>}
                        >
                            <FileText
                                size="20"
                                className="me-3"
                                color="#6c757d"
                                onClick={() => fetchMergedSignedPdfs(true) }
                            />
                        </OverlayTrigger> */}

                            {signedStudentIds.length > 0 &&
                                (loadingMergedPdf ? (
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">
                                            Loading...
                                        </span>
                                    </Spinner>
                                ) : (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>Print Forms</Tooltip>}
                                    >
                                        <Printer
                                            size="20"
                                            className="me-1"
                                            color="#6c757d"
                                            onClick={() =>
                                                fetchMergedSignedPdfs(false)
                                            }
                                        />
                                    </OverlayTrigger>
                                ))}
                        </div>
                    </div>
                    <div>
                        {mergedPdfError && (
                            <Alert variant="info" className="p-2">
                                {mergedPdfError}
                            </Alert>
                        )}
                    </div>
                    {totalStudents === 0 ? (
                        <Alert variant="info" className="p-2">
                            No students found for this template.
                        </Alert>
                    ) : (
                        <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Student</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {studentDropdownData.map(
                                        (student, index) => {
                                            const isSigned =
                                                signedStudentIds.includes(
                                                    student.value
                                                );

                                            return (
                                                <tr key={student.value}>
                                                    <td>{index + 1}</td>
                                                    <td>{student.label}</td>
                                                    <td>
                                                        {isSigned ? (
                                                            <span className="badge bg-success">
                                                                Signed
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-secondary">
                                                                Not Signed
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Card.Body>
            </Card>
            <SnackbarAlert notif={notif} setNotif={setNotif} />

        </>
    );
};

export default StudentSignedDocsTable;
